import { Link } from "react-router-dom";

import { Comment } from "../components/comment/Comment";
import { OfferExpiredCommentDocument } from "./comment.model";
import { CommentBody } from "../components/comment/CommentBody";

interface OfferExpiredCustomerCommentProps {
    comment: OfferExpiredCommentDocument;
}

export const OfferExpiredCustomerComment = (props: OfferExpiredCustomerCommentProps) => {
    const { comment } = props;

    return (
        <Comment date={comment.creationDate.toDate().toISOString()} title="Nej tak (intet svar)">
            <CommentBody>
                <Link to={`/gardeners/context/${comment.gardenerId}`}>{comment.gardenerName}</Link> besvarede ikke tilbuddet inden for 24 timer.<br /><br />

                Det er registreret som nej tak til kunden.
            </CommentBody>
        </Comment>
    );
};
